import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  > div:nth-of-type(3) {
    max-width: 800px;
    margin-top: 60px;
    margin-bottom: 60px;

    > form {
      > div {
        width: 100%;
      }

      > button {
        margin-top: 40px;
        width: 100%;
        outline: 0;
      }
    }

    h1 {
      font-family: 'Montserrat';
      font-size: 4rem;
      color: var(--green24);
      margin: 20px 0px 40px 0px;
    }

    span {
      display: block;
      font-family: 'font-family: ' Montserrat ';';
      font-size: 1rem;
      color: #e84e22;
      margin: 40px 0px 20px 0px;
      cursor: pointer;
    }

    label {
      font-family: 'font-family: ' Montserrat ';';
      font-size: 1.5rem;
      color: #a2a2a2;
      margin-left: 6px;
    }

    input[type='checkbox'] {
      height: 100px;
    }

    > img {
      display: block;
      margin: 100px auto 60px auto;
      cursor: pointer;
    }
  }
`;

export const GradientBackground = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  height: 500px;
  z-index: -1;
  background: #e84e22;
  background: linear-gradient(
    180deg,
    #e84e22 0%,
    rgba(248, 251, 246, 1) 70%,
    rgba(255, 255, 255, 1) 80%
  );
`;

export const FreeTrialMessage = styled.div`
  font-family: 'Montserrat';
  font-size: 1.3rem;
  color: var(--green24);
  padding: 10px;
  max-width: 280px;
  box-shadow: 0px 0px 6px 0px lightgrey;
  background-color: #fff;
  border-radius: var(--border10);
  text-align: center;
`;

export const Row = styled.div`
  display: flex;
`;

export const Tooltip = styled.div`
  font-family: 'Montserrat';
  font-size: 1.2rem;
  margin-top: 20px;
  color: #e84e22;
  text-align: center;
`;
